import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import LoanOfficerQuestions from "@/pages/tools/LoanOfficerQuestions";

export const Route = createFileRoute("/tools/loan-officer-questions")({
  head: () => seoHead("/tools/loan-officer-questions"),
  component: LoanOfficerQuestions,
});
